import createIcon from '../../createIcon';

/**
 * @component @name Reply
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgOC41VjQuNUwzIDExLjVMMTAgMTguNVYxNC40QzE1IDE0LjQgMTguNSAxNiAyMSAxOS41QzIwIDE0LjUgMTcgOS41IDEwIDguNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Reply = createIcon('Reply', [
  [
    'path',
    {
      d: 'M10 8.5V4.5L3 11.5L10 18.5V14.4C15 14.4 18.5 16 21 19.5C20 14.5 17 9.5 10 8.5Z',
      key: 'wl1tb2',
    },
  ],
]);

export default Reply;
